import type { CSSProperties } from 'react';
import type { LeaveTypeView } from '../models/attendance';

/**
 * Returns color-related styling for a leave type badge.
 * When a color is configured, returns inline styles; otherwise returns Tailwind fallback classes.
 */
export function getLeaveTypeBadgeStyle(
  typeName: string,
  leaveTypes?: LeaveTypeView[]
): { colorClass: string; style?: CSSProperties } {
  const leaveType = leaveTypes?.find(
    lt => lt.name?.toLowerCase() === typeName?.toLowerCase()
  );

  if (leaveType?.color) {
    return {
      colorClass: '',
      style: { backgroundColor: `${leaveType.color}20`, color: '#000000' },
    };
  }

  return {
    colorClass: 'text-gray-600 bg-gray-100',
  };
}
